import React from "react"
import { Container, Row, Col } from "@bootstrap-styled/v4"
import { Element } from "react-scroll"
import WOW from "react-wow"
import { StaticQuery, graphql } from "gatsby"

import Button from "src/components/ui/Button"
import BlogItem from "../../ui/BlogItem"

import * as S from "./styled"

const BlogDestaques = () => (
  <StaticQuery
    query={graphql`
      query {
        content: allMarkdownRemark(
          filter: { fileAbsolutePath: { regex: "/(posts)/.*.md$/" } }
          limit: 3
          sort: { fields: frontmatter___date, order: DESC }
        ) {
          edges {
            node {
              fields {
                slug
              }
              frontmatter {
                title
                description
                image {
                  childImageSharp {
                    fluid(maxWidth: 450) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <Element name="section-blog">
        <S.BlogDestaquesWrapper>
          <Container>
            <S.BlogDestaquesHeader>
              <WOW animation="fadeInUp">
                <S.BlogDestaquesDesc>{`Você também pode gostar...`}</S.BlogDestaquesDesc>
                <S.BlogDestaquesTitle>
                  {`Notícias em destaque`}
                </S.BlogDestaquesTitle>
              </WOW>
            </S.BlogDestaquesHeader>
          </Container>
          <S.BlogDestaquesContent>
            <Container>
              <Row>
                {data.content.edges.map((item, i) => (
                  <WOW animation="fadeIn" key={i}>
                    <Col
                      xs={12}
                      md={6}
                      lg={4}
                      style={{
                        display: "flex",
                        alignItems: "stretch",
                        marginBottom: "25px",
                      }}
                    >
                      <BlogItem
                        slug={item.node.fields.slug}
                        title={item.node.frontmatter.title}
                        description={item.node.frontmatter.description}
                        img={item.node.frontmatter.image}
                      />
                    </Col>
                  </WOW>
                ))}
              </Row>

              <WOW animation="zoomIn">
                <S.BlogDestaquesMore to="/blog">
                  <Button hasIconAfter="News" color="primary" size="lg">
                    Voltar para o blog
                  </Button>
                </S.BlogDestaquesMore>
              </WOW>
            </Container>
          </S.BlogDestaquesContent>
        </S.BlogDestaquesWrapper>
      </Element>
    )}
  />
)

export default BlogDestaques
